export function registerServiceWorker() {
  if (process.env.NODE_ENV !== "production") return; // avoid dev-server cache confusion
  if (!("serviceWorker" in navigator)) return;

  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register(`${process.env.PUBLIC_URL}/service-worker.js`)
      .catch((err) => console.error("Service worker registration failed:", err));
  });
}
